export default __webpack_public_path__ + "static/stage-2_3-20afb1813fddb0edf283118f9ed5b437.jpg";